import { createContext } from "react";

const itemCategoryContext = createContext();

export default itemCategoryContext;
